import { memo } from 'react';

import type { SVGProps } from 'react';
const SvgImageAiEscrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 29"
    role="img"
    className={props.className}
    {...props}
  >
    <path
      fill="#1B9BA0"
      d="M.404 16.81V2.89c0-1.175.959-2.128 2.141-2.128H22.35c1.183 0 2.141.953 2.141 2.129V16.81a7.97 7.97 0 0 1-3.783 6.776l-7.128 4.416c-.693.429-1.57.429-2.264 0l-7.128-4.416A7.97 7.97 0 0 1 .404 16.81"
    />
    <path
      fill="#09898E"
      d="M22.352.762c1.182 0 2.14.953 2.14 2.129V16.81a7.97 7.97 0 0 1-3.783 6.776l-7.128 4.416c-.347.215-.74.32-1.134.32V.762z"
    />
    <path
      fill="#1B9BA0"
      fillRule="evenodd"
      d="M2.544 1.157c-.96 0-1.74.77-1.74 1.72v13.845A7.53 7.53 0 0 0 4.4 23.124l7.128 4.392a1.76 1.76 0 0 0 1.84 0l7.127-4.392a7.53 7.53 0 0 0 3.594-6.402V2.878c0-.95-.779-1.72-1.74-1.72zM.002 2.877C.002 1.49 1.14.364 2.544.364h19.804c1.405 0 2.543 1.126 2.543 2.515v13.844a8.32 8.32 0 0 1-3.972 7.076L13.79 28.19a2.57 2.57 0 0 1-2.69 0l-7.127-4.392a8.32 8.32 0 0 1-3.972-7.076z"
      clipRule="evenodd"
    />
    <g clipPath="url(#image-ai-escrow_svg__clip0_28393_9026)">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="m11.525 10.412-2.113 2.113m.38.975a1.354 1.354 0 1 1-2.709 0 1.354 1.354 0 0 1 2.708 0m0 0h5.416m0 0a1.354 1.354 0 1 0 2.708 0 1.354 1.354 0 0 0-2.708 0m-1.733 3.087 2.112-2.112m-1.733-5.038a1.354 1.354 0 1 1-2.708 0 1.354 1.354 0 0 1 2.708 0m0 8.125a1.354 1.354 0 1 1-2.708 0 1.354 1.354 0 0 1 2.708 0"
      />
    </g>
  </svg>
);
const Memo = memo(SvgImageAiEscrow);
export default Memo;
